import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: ({ hasColumnLayout, hasValue, isDisabled, isReadOnly, validationState }) => ({
    thRoot: classnames('flex items-center', {
      'flex-col gap-5 text-center': hasColumnLayout,
      'justify-between gap-10': !hasColumnLayout,
    }),
    thLabel: classnames('text-14', {
      'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
      'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
      'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled,
    }),
    thNotes: 'block text-10',
    thInputs: 'flex gap-5 items-center shrink-0',
    thInput: classnames('outline-custom h-30 text-center text-18 font-bold leading-[1.875em]', {
      'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
      'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
      'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled,
    }),
    thButton:
      'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in size-48',
    thButtonIconWidth: '0.625rem',
  }),
};
